var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestorationWhiteColor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12004_3098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 9.77734H3.16663V10.6662H13.8333V9.77734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 11.5557H12.0555V12.4446H13.8333V11.5557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5465 6.67292L9.08069 8.13494L9.03843 3.32954C9.03757 3.2315 8.9978 3.13782 8.92786 3.06911C8.85793 3.0004 8.76357 2.96228 8.66553 2.96314C8.5675 2.964 8.47382 3.00378 8.4051 3.07371C8.33639 3.14364 8.29827 3.238 8.29914 3.33604L8.3414 8.14144L6.84997 6.69434C6.81448 6.66116 6.77281 6.63529 6.72732 6.61821C6.68183 6.60113 6.63343 6.59318 6.58487 6.59481C6.53631 6.59644 6.48855 6.60761 6.44431 6.6277C6.40007 6.64779 6.36022 6.67639 6.32703 6.71188C6.29385 6.74737 6.26798 6.78904 6.2509 6.83453C6.23382 6.88002 6.22587 6.92842 6.2275 6.97698C6.22913 7.02554 6.2403 7.0733 6.26039 7.11754C6.28048 7.16178 6.30908 7.20163 6.34457 7.23482L8.72353 9.55763L11.065 7.1933C11.1216 7.12235 11.1501 7.03305 11.1451 6.94241C11.1401 6.85177 11.102 6.76613 11.0379 6.70182C10.9738 6.63751 10.8883 6.59902 10.7977 6.59369C10.7071 6.58836 10.6177 6.61657 10.5465 6.67292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2067 5.94256C14.1513 5.76216 14.0383 5.6049 13.885 5.49492C13.7316 5.38493 13.5464 5.32828 13.3578 5.33367H9.83336V6.22256H13.3667C13.8334 7.52923 14.5978 9.62256 14.7222 9.99145V13.3337H2.2778V9.99145C2.40225 9.62256 3.63336 6.22256 3.63336 6.22256H7.16669V5.33367H3.64225C3.45685 5.32636 3.27412 5.37967 3.12174 5.48554C2.96937 5.5914 2.85564 5.74404 2.7978 5.92034C1.38892 9.77812 1.38892 9.82256 1.38892 9.92478V13.3337C1.38892 13.5694 1.48257 13.7955 1.64927 13.9622C1.81596 14.1289 2.04206 14.2226 2.2778 14.2226H14.7222C14.958 14.2226 15.1841 14.1289 15.3508 13.9622C15.5175 13.7955 15.6111 13.5694 15.6111 13.3337V9.92478C15.6111 9.82256 15.6111 9.77812 14.2067 5.94256Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12004_3098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestorationWhiteColor);
export default __webpack_public_path__ + "static/media/RestorationWhiteColor.4da15df668fae7efa4ac10f2795d6b0d.svg";
export { ForwardRef as ReactComponent };